import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Container, Input, Label, Row, Spinner } from "reactstrap";

import SettingApi from "api/settingApi";
import BreadCrumb from "components/Common/BreadCrumb";
import DragMenu from "components/Common/DragMenu";
import * as Yup from "yup";

import IconJobList from "../../../assets/images/icons/ic_ms_shop.svg";
import IconJobListWhite from "../../../assets/images/icons/ic_ms_shop_selected.svg";
import IconProfile from "../../../assets/images/icons/ic_ms_person.svg";
import IconProfileWhite from "../../../assets/images/icons/ic_ms_person_selected.svg";
import IconTalent from "../../../assets/images/icons/ic_ms_search.svg";
import IconTalentWhite from "../../../assets/images/icons/ic_ms_search_selected.svg";
import IconManager from "../../../assets/images/icons/ic_ms_edit.svg";
import IconManagerWhite from "../../../assets/images/icons/ic_ms_edit_selected.svg";
import IconCommunity from "../../../assets/images/icons/ic_community.svg";
import IconCommunityWhite from "../../../assets/images/icons/ic_community_selected.svg";
import IconChat from "../../../assets/images/icons/ic_chat.svg";
import IconChatWhite from "../../../assets/images/icons/ic_chat_selected.svg";

import SelectMenu from "components/Common/SelectMenu";
import { LIST_SETTING_JOB_METHOD_OPTION } from "helpers/constans";
import TextArea from "antd/es/input/TextArea";
import PhoneInput from "components/Common/PhoneInput";
import { PatternFormat } from "react-number-format";
import regionApi from "api/regionApi";
import DropdownOptionNew from "components/Common/DropdownOptionNew";

registerLocale("en", en);
registerLocale("ko", ko);

const APP_MODE_IOS = [
  {
    id: "jobSeeker",
    text: "Job Seeker",
    checked: true,
  },
  {
    id: "recruiter",
    text: "Recruiter",
    checked: true,
  },
];

const APP_MODE_ANDROID = [
  {
    id: "jobSeeker",
    text: "Job Seeker",
    checked: true,
  },
  {
    id: "recruiter",
    text: "Recruiter",
    checked: true,
  },
];

const JOB_SEEKER_BOTTOM_MENU_ON_IOS = [
  {
    id: "jobList",
    text: "Job List",
    icon: IconJobList,
    iconEnable: IconJobListWhite,
    checked: true,
  },
  {
    id: "findTalent",
    text: "Talent Registration",
    icon: IconTalent,
    iconEnable: IconTalentWhite,
    checked: true,
  },
  {
    id: "community",
    text: "Community",
    icon: IconCommunity,
    iconEnable: IconCommunityWhite,
    checked: true,
  },
  {
    id: "profile",
    text: "Profile",
    icon: IconProfile,
    iconEnable: IconProfileWhite,
    checked: true,
  },
  {
    id: "chat",
    text: "Chat",
    icon: IconChat,
    iconEnable: IconChatWhite,
    checked: true,
  },
];

const JOB_SEEKER_BOTTOM_MENU_ON_ANDROID = [
  {
    id: "jobList",
    text: "Job List",
    icon: IconJobList,
    iconEnable: IconJobListWhite,
    checked: true,
  },
  {
    id: "findTalent",
    text: "Talent Registration",
    icon: IconTalent,
    iconEnable: IconTalentWhite,
    checked: true,
  },
  {
    id: "community",
    text: "Community",
    icon: IconCommunity,
    iconEnable: IconCommunityWhite,
    checked: true,
  },
  {
    id: "chat",
    text: "Chat",
    icon: IconChat,
    iconEnable: IconChatWhite,
    checked: true,
  },
  {
    id: "profile",
    text: "Profile",
    icon: IconProfile,
    iconEnable: IconProfileWhite,
    checked: true,
  },
];

const RECRUITER_BOTTOM_MENU_ON_IOS = [
  {
    id: "jobList",
    text: "Job List",
    icon: IconJobList,
    iconEnable: IconJobListWhite,
    checked: true,
  },
  {
    id: "findTalent",
    text: "Find Talent",
    icon: IconTalent,
    iconEnable: IconTalentWhite,
    checked: true,
  },
  {
    id: "manageRecruiter",
    text: "Manage Recruit",
    icon: IconManager,
    iconEnable: IconManagerWhite,
    checked: true,
  },
{
    id: "chat",
    text: "Chat",
    icon: IconChat,
    iconEnable: IconChatWhite,
    checked: true,
  },
  {
    id: "profile",
    text: "Profile",
    icon: IconProfile,
    iconEnable: IconProfileWhite,
    checked: true,
  },
];

const RECRUITER_BOTTOM_MENU_ON_ANDROID = [
  {
    id: "jobList",
    text: "Job List",
    icon: IconJobList,
    iconEnable: IconJobListWhite,
    checked: true,
  },
  {
    id: "findTalent",
    text: "Find Talent",
    icon: IconTalent,
    iconEnable: IconTalentWhite,
    checked: true,
  },
  {
    id: "manageRecruiter",
    text: "Manage Recruit",
    icon: IconManager,
    iconEnable: IconManagerWhite,
    checked: true,
  },
  {
    id: "chat",
    text: "Chat",
    icon: IconChat,
    iconEnable: IconChatWhite,
    checked: true,
  },
  {
    id: "profile",
    text: "Profile",
    icon: IconProfile,
    iconEnable: IconProfileWhite,
    checked: true,
  },
];

const AppSetting = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    if (!formik?.isValid) {
      return;
    }
    setIsLoading(true);

    console.log(values);
    // return;

    const formatedData = {
      minIOSVersion: values?.minIOSVersion,
      maxIOSVersion: values?.maxIOSVersion,
      minAndroidVersion: values?.minAndroidVersion,
      maxAndroidVersion: values?.maxAndroidVersion,
      appUserTypeModeIOS: values?.appUserTypeModeIOS?.reduce(
        (acc: any, item: any) => {
          acc[item.id] = item?.checked ? 1 : 0;
          return acc;
        },
        {}
      ),
      appUserTypeModeAndroid: values?.appUserTypeModeAndroid?.reduce(
        (acc: any, item: any) => {
          acc[item.id] = item?.checked ? 1 : 0;
          return acc;
        },
        {}
      ),
      jobSeekerMenuIOS: values?.jobSeekerMenuIOS
        ?.filter((i: any) => !!i?.checked)
        ?.map((item: any) => item?.id),
      jobSeekerMenuAndroid: values?.jobSeekerMenuAndroid
        ?.filter((i: any) => !!i?.checked)
        ?.map((item: any) => item?.id),
      recruiterMenuIOS: values?.recruiterMenuIOS
        ?.filter((i: any) => !!i?.checked)
        ?.map((item: any) => item?.id),
      recruiterMenuAndroid: values?.recruiterMenuAndroid
        ?.filter((i: any) => !!i?.checked)
        ?.map((item: any) => item?.id),
      adultVerificationIOS: values?.adultVerificationIOS ? 1 : 0,
      adultVerificationAndroid: values?.adultVerificationAndroid ? 1 : 0,
      enableAdultVerifyFirstLaunch: values?.enableAdultVerifyFirstLaunch
        ? 1
        : 0,
      resumeViewDaysAfterExpiration: values?.resumeViewDaysAfterExpiration,

      kakaoChannel: values?.kakaoChannel,
      adultVerificationProviderUrl: values?.adultVerificationProviderUrl,
      jobPostFlow: values?.jobPostFlow,
      paymentFlow: values?.paymentFlow,
      jobPostPurchaseWebURL: values?.jobPostPurchaseWebURL,
      jobPostCreateWebNotice: values?.jobPostCreateWebNotice,
      jobPostPurchaseWebNotice: values?.jobPostPurchaseWebNotice,
      vocEnable: values?.vocEnable ? 1 : 0,
      appEntry: {
        enabled: values?.appEntry ? 1 : 0,
        entryThreshold: +values?.entryThreshold,
      },
      accountDeletion: {
        enabled: values?.accountDeletion ? 1 : 0,
      },
      importantNoteCreateJobPostiOS: values?.importantNoteCreateJobPostiOS,
      importantNoteCreateJobPostAndroid:
        values?.importantNoteCreateJobPostAndroid,
      importantNoteCreateJobPostFold: values?.importantNoteCreateJobPostFold,

      companyName: values?.companyName,
      ceoName: values?.ceoName,
      businessRegistrationNumber: values?.businessRegistrationNumber,
      contactEmail: values?.contactEmail,
      contactPhone: values?.contactPhone,
      companyAddress: values?.companyAddress,
      termsOfServiceUrl: values?.termsOfServiceUrl,
      privacyPolicyUrl: values?.privacyPolicyUrl,
      personalInfoConsentUrl: values?.personalInfoConsentUrl,
      eventPromotionConsentUrl: values?.eventPromotionConsentUrl,
      thirdPartyProvidingUrl: values?.thirdPartyProvidingUrl,
      screenCaptureProtection: values?.screenCaptureProtection,

      defaultRegion: values?.defaultRegion,
      defaultSubRegion: values?.defaultSubRegion
    };

    try {
      const response: any = await SettingApi.postSetting(formatedData);
      if (response?.code === 200) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsLoading((_prev) => false);
        if (response.success == false) {
          toast(`${response?.message}`, CONFIG_OPTION_TOAST_ERROR);
        }
      }
    } catch (error: any) {
      toast(`${error}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    minIOSVersion: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    minAndroidVersion: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    maxIOSVersion: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    maxAndroidVersion: Yup.string()
      .matches(/^\d+\.\d+\.\d+$/, t("invalid_version"))
      .required(t("required_version")),
    jobSeekerMenuIOS: Yup.array().test(
      "at-least-two-checked",
      t("Minimum 2 items"),
      function (value) {
        const checkedCount = value?.filter((item) => item.checked).length || 0;
        return checkedCount >= 2;
      }
    ),
    jobSeekerMenuAndroid: Yup.array().test(
      "at-least-two-checked",
      t("Minimum 2 items"),
      function (value) {
        const checkedCount = value?.filter((item) => item.checked).length || 0;
        return checkedCount >= 2;
      }
    ),
    recruiterMenuIOS: Yup.array().test(
      "at-least-two-checked",
      t("Minimum 2 items"),
      function (value) {
        const checkedCount = value?.filter((item) => item.checked).length || 0;
        return checkedCount >= 2;
      }
    ),
    recruiterMenuAndroid: Yup.array().test(
      "at-least-two-checked",
      t("Minimum 2 items"),
      function (value) {
        const checkedCount = value?.filter((item) => item.checked).length || 0;
        return checkedCount >= 2;
      }
    ),
    companyName: Yup.string().required(t("This field is required")),
    adultVerificationProviderUrl: Yup.string()
      .matches(/^https:\/\/.+/, "Invalid URL format")
      .url("Invalid URL format")
      .required(t("This field is required")),
    jobPostPurchaseWebURL: Yup.string()
      .matches(/^https:\/\/.+/, "Invalid URL format")
      .url("Invalid URL format")
      .required(t("This field is required")),
    jobPostCreateWebNotice: Yup.string().required(t("This field is required")),
    jobPostPurchaseWebNotice: Yup.string().required(
      t("This field is required")
    ),
    importantNoteCreateJobPostiOS: Yup.string().required(
      t("This field is required")
    ),
    importantNoteCreateJobPostAndroid: Yup.string().required(
      t("This field is required")
    ),
    importantNoteCreateJobPostFold: Yup.string().required(
      t("This field is required")
    ),

    kakaoChannel: Yup.string().required(t("This field is required")),
    ceoName: Yup.string().required(t("This field is required")),
    businessRegistrationNumber: Yup.string().required(
      t("This field is required")
    ),
    contactEmail: Yup.string()
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, t("Invalid email address"))
      .required(t("This field is required")),
    contactPhone: Yup.string().required(t("This field is required")),
    companyAddress: Yup.string().required(t("This field is required")),
    termsOfServiceUrl: Yup.string()
      .matches(/^https:\/\/.+/, "Invalid URL format")
      .url("Invalid URL format")
      .required(t("This field is required")),
    privacyPolicyUrl: Yup.string()
      .matches(/^https:\/\/.+/, "Invalid URL format")
      .url("Invalid URL format")
      .required(t("This field is required")),
    personalInfoConsentUrl: Yup.string()
      .matches(/^https:\/\/.+/, "Invalid URL format")
      .url("Invalid URL format")
      .required(t("This field is required")),
    eventPromotionConsentUrl: Yup.string()
      .matches(/^https:\/\/.+/, "Invalid URL format")
      .url("Invalid URL format")
      .required(t("This field is required")),
    thirdPartyProvidingUrl: Yup.string()
      .matches(/^https:\/\/.+/, "Invalid URL format")
      .url("Invalid URL format")
      .required(t("This field is required")),
  });

  const formik = useFormik({
    initialValues: {
      minIOSVersion: "",
      minAndroidVersion: "",
      maxIOSVersion: "",
      maxAndroidVersion: "",
      appUserTypeModeIOS: APP_MODE_IOS,
      appUserTypeModeAndroid: APP_MODE_ANDROID,
      jobSeekerMenuIOS: JOB_SEEKER_BOTTOM_MENU_ON_IOS,
      jobSeekerMenuAndroid: JOB_SEEKER_BOTTOM_MENU_ON_ANDROID,
      recruiterMenuIOS: RECRUITER_BOTTOM_MENU_ON_IOS,
      recruiterMenuAndroid: RECRUITER_BOTTOM_MENU_ON_ANDROID,
      adultVerificationIOS: false,
      adultVerificationAndroid: false,
      enableAdultVerifyFirstLaunch: false,
      resumeViewDaysAfterExpiration: "",

      kakaoChannel: "",
      adultVerificationProviderUrl: "",
      jobPostFlow: "web",
      paymentFlow: "web",
      jobPostPurchaseWebURL: "",
      jobPostCreateWebNotice: "",
      jobPostPurchaseWebNotice: "",
      vocEnable: 0,
      appEntry: 0,
      entryThreshold: 10,
      accountDeletion: 0,

      importantNoteCreateJobPostiOS: "",
      importantNoteCreateJobPostAndroid: "",
      importantNoteCreateJobPostFold: "",

      companyName: "",
      ceoName: "",
      businessRegistrationNumber: "",
      contactEmail: "",
      contactPhone: "",
      companyAddress: "",
      termsOfServiceUrl: "",
      privacyPolicyUrl: "",
      personalInfoConsentUrl: "",
      eventPromotionConsentUrl: "",
      thirdPartyProvidingUrl: "",
      screenCaptureProtection: 0,
      defaultRegion: {
        id: null,
        name: ""
      },
      defaultSubRegion: {
        id: "",
        name: ""
      }
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleSort = (arr: any, arr2: any) => {
    const orderMap = new Map(arr2.map((id: any, index: any) => [id, index]));

    const sortedArr = arr
      ?.map((item: any) => ({
        ...item,
        checked: !!arr2.includes(item.id),
      }))
      .slice()
      .sort((a: any, b: any) => {
        const aOrder: any = orderMap.has(a.id) ? orderMap.get(a.id) : Infinity;
        const bOrder: any = orderMap.has(b.id) ? orderMap.get(b.id) : Infinity;
        return aOrder - bOrder;
      });

    return sortedArr;
  };
  // handleSort(JOB_SEEKER_BOTTOM_MENU_ON_IOS, ["profile", "jobList"]);

  useEffect(() => {
    document.title = `${t("App Setting")} - ${t("Setting Manager")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  const handleData = async () => {
    setIsLoading((_prev) => true);
    try {
      const response: any = await SettingApi.getSetting();
      // handleSort(
      //   JOB_SEEKER_BOTTOM_MENU_ON_IOS,
      //   response?.data?.jobSeekerMenuIOS
      // );
      formik?.setValues({
        minIOSVersion: response?.data?.minIOSVersion || "",
        minAndroidVersion: response?.data?.minAndroidVersion || "",
        maxIOSVersion: response?.data?.maxIOSVersion || "",
        maxAndroidVersion: response?.data?.maxAndroidVersion || "",
        appUserTypeModeIOS: APP_MODE_IOS?.map((item: any) => ({
          ...item,
          checked: !!response?.data?.appUserTypeModeIOS?.[item?.id],
        })),
        appUserTypeModeAndroid: APP_MODE_ANDROID?.map((item: any) => ({
          ...item,
          checked: !!response?.data?.appUserTypeModeAndroid?.[item?.id],
        })),
        jobSeekerMenuIOS: handleSort(
          JOB_SEEKER_BOTTOM_MENU_ON_IOS,
          response?.data?.jobSeekerMenuIOS
        ),
        jobSeekerMenuAndroid: handleSort(
          JOB_SEEKER_BOTTOM_MENU_ON_ANDROID,
          response?.data?.jobSeekerMenuAndroid
        ),
        recruiterMenuIOS: handleSort(
          RECRUITER_BOTTOM_MENU_ON_IOS,
          response?.data?.recruiterMenuIOS
        ),
        recruiterMenuAndroid: handleSort(
          RECRUITER_BOTTOM_MENU_ON_ANDROID,
          response?.data?.recruiterMenuAndroid
        ),
        adultVerificationIOS: !!response?.data?.adultVerificationIOS,
        adultVerificationAndroid: !!response?.data?.adultVerificationAndroid,
        enableAdultVerifyFirstLaunch:
          !!response?.data?.enableAdultVerifyFirstLaunch,
        resumeViewDaysAfterExpiration:
          response?.data?.resumeViewDaysAfterExpiration,

        kakaoChannel: response?.data?.kakaoChannel,
        adultVerificationProviderUrl:
          response?.data?.adultVerificationProviderUrl,
        jobPostFlow: response?.data?.jobPostFlow,
        paymentFlow: response?.data?.paymentFlow,
        jobPostPurchaseWebURL: response?.data?.jobPostPurchaseWebURL,
        jobPostCreateWebNotice: response?.data?.jobPostCreateWebNotice,
        jobPostPurchaseWebNotice: response?.data?.jobPostPurchaseWebNotice,

        vocEnable: response?.data?.vocEnable,
        appEntry: response?.data?.appEntry?.enabled,
        entryThreshold: response?.data?.appEntry?.entryThreshold,
        accountDeletion: response?.data?.accountDeletion?.enabled,

        importantNoteCreateJobPostiOS:
          response?.data?.importantNoteCreateJobPostiOS,
        importantNoteCreateJobPostAndroid:
          response?.data?.importantNoteCreateJobPostAndroid,
        importantNoteCreateJobPostFold:
          response?.data?.importantNoteCreateJobPostFold,

        companyName: response?.data?.companyName,
        ceoName: response?.data?.ceoName,
        businessRegistrationNumber: response?.data?.businessRegistrationNumber,
        contactEmail: response?.data?.contactEmail,
        contactPhone: response?.data?.contactPhone,
        companyAddress: response?.data?.companyAddress,
        termsOfServiceUrl: response?.data?.termsOfServiceUrl,
        privacyPolicyUrl: response?.data?.privacyPolicyUrl,
        personalInfoConsentUrl: response?.data?.personalInfoConsentUrl,
        eventPromotionConsentUrl: response?.data?.eventPromotionConsentUrl,
        thirdPartyProvidingUrl: response?.data?.thirdPartyProvidingUrl,
        screenCaptureProtection: response?.data?.screenCaptureProtection,

        defaultRegion: response?.data?.defaultRegion,
        defaultSubRegion: response?.data?.defaultSubRegion
      });
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading((_prev) => false);
    }
  };

  useEffect(() => {
    handleData();
  }, []);

  const [regions, setRegions] = useState<any>(null);
  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const resRegion: any = await regionApi.getRegions();
        if (resRegion?.data) {
          const formatRegions = resRegion?.data?.map((item: any) => {
            const formatSubRegion =  item?.subRegions?.map((sub: any) => {
              return {
                value: sub?.id,
                label: sub?.name
              }
            })
            return {
              value: item?.id,
              label: item?.name,
              subOptions: formatSubRegion || []
            }
          })
          setRegions(formatRegions)
        }
      } catch (error: any) {
        return error;
      }
    };

    handleCallAllOption();
  }, [])

  return (
    <React.Fragment>
      <div className="page-content  app-setting">
        <Container fluid>
          <BreadCrumb title={t("App Setting")} pageTitle={t("Home")} />
          <form onSubmit={formik.handleSubmit}>
            <Row className="mt-3">
              <Col lg={6} xl={6} xxl={6}>
                <div
                  className="position-relative mb-3 mt-1 mt-md-0"
                  style={{
                    border: "1px dashed var(--vz-primary)",
                    borderRadius: "4px",
                    padding: "10px",
                  }}
                >
                  <span
                    className="text-primary position-absolute fs-13 px-1"
                    style={{
                      backgroundColor: "var(--vz-secondary-bg)",
                      top: "0px",
                      transform: "translateY(-50%)",
                    }}
                  >
                    {t("General")}
                  </span>

                  <Row>
                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="minIOSVersion" className="form-label">
                          {t("min_ios_version")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="minIOSVersion"
                          type="text"
                          className="form-control"
                          id="titleInput"
                          placeholder={t("enter_min_ios_version")}
                          value={formik?.values?.minIOSVersion}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "minIOSVersion",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.minIOSVersion &&
                        formik?.errors?.minIOSVersion ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.minIOSVersion}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="maxIOSVersion" className="form-label">
                          {t("latest_ios_version")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="maxIOSVersion"
                          type="text"
                          className="form-control"
                          id="titleInput"
                          placeholder={t("enter_latest_ios_version")}
                          value={formik?.values?.maxAndroidVersion}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "maxAndroidVersion",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.maxAndroidVersion &&
                        formik?.errors?.maxAndroidVersion ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.maxAndroidVersion}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="minAndroidVersion"
                          className="form-label"
                        >
                          {t("min_android_version")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="minAndroidVersion"
                          type="text"
                          className="form-control"
                          id="titleInput"
                          placeholder={t("enter_min_android_version")}
                          value={formik?.values?.minAndroidVersion}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "minAndroidVersion",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.minAndroidVersion &&
                        formik?.errors?.minAndroidVersion ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.minAndroidVersion}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="maxAndroidVersion"
                          className="form-label"
                        >
                          {t("latest_android_version")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="maxAndroidVersion"
                          type="text"
                          className="form-control"
                          id="titleInput"
                          placeholder={t("enter_latest_android_version")}
                          value={formik?.values?.maxIOSVersion}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "maxIOSVersion",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.maxIOSVersion &&
                        formik?.errors?.maxIOSVersion ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.maxIOSVersion}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="appUserTypeModeIOS"
                          className="form-label"
                        >
                          {t("App Mode IOS")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <SelectMenu
                          menuList={formik.values?.appUserTypeModeIOS}
                          name="appUserTypeModeIOS"
                          formik={formik}
                        />
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="appUserTypeModeAndroid"
                          className="form-label"
                        >
                          {t("App Mode Android")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <SelectMenu
                          menuList={formik.values?.appUserTypeModeAndroid}
                          name="appUserTypeModeAndroid"
                          formik={formik}
                        />
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="jobSeekerMenuIOS"
                          className="form-label"
                        >
                          {t("Job Seeker - Bottom Menu On IOS")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <DragMenu
                          menuList={formik.values?.jobSeekerMenuIOS}
                          name="jobSeekerMenuIOS"
                          onChange={(e: any) => {
                            formik.setFieldValue("jobSeekerMenuIOS", e);
                          }}
                        />

                        {formik?.touched?.jobSeekerMenuIOS &&
                        formik?.errors?.jobSeekerMenuIOS ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.jobSeekerMenuIOS + ""}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="jobSeekerMenuAndroid"
                          className="form-label"
                        >
                          {t("Job Seeker - Bottom Menu On Android")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <DragMenu
                          menuList={formik.values?.jobSeekerMenuAndroid}
                          name="jobSeekerMenuAndroid"
                          onChange={(e: any) => {
                            formik.setFieldValue("jobSeekerMenuAndroid", e);
                          }}
                        />
                        {formik?.touched?.jobSeekerMenuAndroid &&
                        formik?.errors?.jobSeekerMenuAndroid ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.jobSeekerMenuAndroid + ""}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="recruiterMenuIOS"
                          className="form-label"
                        >
                          {t("Recruiter - Bottom Menu On IOS")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <DragMenu
                          menuList={formik.values?.recruiterMenuIOS}
                          name="recruiterMenuIOS"
                          onChange={(e: any) => {
                            formik.setFieldValue("recruiterMenuIOS", e);
                          }}
                        />
                        {formik?.touched?.recruiterMenuIOS &&
                        formik?.errors?.recruiterMenuIOS ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.recruiterMenuIOS + ""}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="recruiterMenuAndroid"
                          className="form-label"
                        >
                          {t("Recruiter - Bottom Menu On Android")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <DragMenu
                          menuList={formik.values?.recruiterMenuAndroid}
                          name="recruiterMenuAndroid"
                          onChange={(e: any) => {
                            formik.setFieldValue("recruiterMenuAndroid", e);
                          }}
                        />
                        {formik?.touched?.recruiterMenuAndroid &&
                        formik?.errors?.recruiterMenuAndroid ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.recruiterMenuAndroid + ""}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="kakaoChannel" className="form-label">
                          {t("Kakao Channel")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="kakaoChannel"
                          type="text"
                          className="form-control"
                          id="kakaoChannel"
                          placeholder={t("Kakao Channel")}
                          value={formik?.values?.kakaoChannel}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "kakaoChannel",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.kakaoChannel &&
                        formik?.errors?.kakaoChannel ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.kakaoChannel}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-2">
                        <Label
                          htmlFor="adultVerificationProviderUrl"
                          className="form-label"
                        >
                          {t("Adult verification link")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="adultVerificationProviderUrl"
                          type="text"
                          className="form-control"
                          id="adultVerificationProviderUrlInput"
                          placeholder={t("Adult verification link")}
                          value={formik?.values?.adultVerificationProviderUrl}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "adultVerificationProviderUrl",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.adultVerificationProviderUrl &&
                        formik?.errors?.adultVerificationProviderUrl ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.adultVerificationProviderUrl}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12} className="mt-2">
                      <div className="d-flex gap-2">
                        <Label
                          htmlFor="newpasswordInput"
                          className="form-label"
                          style={{ minWidth: "200px" }}
                        >
                          {t("Adult Verification IOS")}{" "}
                        </Label>
                        <div className="form-check form-switch mb-0">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="adultVerificationIOS"
                            name="adultVerificationIOS"
                            checked={!!formik?.values?.adultVerificationIOS}
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "adultVerificationIOS",
                                Number(event?.target.checked)
                              )
                            }
                          />
                        </div>
                      </div>
                    </Col>

                    <Col lg={12} className="mt-2">
                      <div className="d-flex gap-2">
                        <Label
                          htmlFor="newpasswordInput"
                          className="form-label"
                          style={{ minWidth: "200px" }}
                        >
                          {t("Adult Verification Android")}{" "}
                        </Label>
                        <div className="form-check form-switch mb-0">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="adultVerificationAndroid"
                            name="adultVerificationAndroid"
                            checked={!!formik?.values?.adultVerificationAndroid}
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "adultVerificationAndroid",
                                Number(event?.target.checked)
                              )
                            }
                          />
                        </div>
                      </div>
                    </Col>

                    <Col lg={12} className="mt-2">
                      <div className="d-flex gap-2">
                        <Label
                          htmlFor="newpasswordInput"
                          className="form-label"
                          style={{ minWidth: "200px" }}
                        >
                          {t("adult_verification_first_launch")}{" "}
                        </Label>
                        <div className="form-check form-switch mb-0">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="enableAdultVerifyFirstLaunch"
                            name="enableAdultVerifyFirstLaunch"
                            checked={
                              !!formik?.values?.enableAdultVerifyFirstLaunch
                            }
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "enableAdultVerifyFirstLaunch",
                                Number(event?.target.checked)
                              )
                            }
                          />
                        </div>
                      </div>
                    </Col>

                    <Col lg={12} className="mt-2">
                      <div className="d-flex gap-2">
                        <Label
                          htmlFor="screenCaptureProtection"
                          className="form-label"
                          style={{ minWidth: "114px" }}
                        >
                          {t("Screen Capture Protection")}{" "}
                        </Label>
                        <div className="form-check form-switch mb-0">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="screenCaptureProtection"
                            name="screenCaptureProtection"
                            checked={!!formik?.values?.screenCaptureProtection}
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "screenCaptureProtection",
                                Number(event?.target.checked)
                              )
                            }
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <div
                  className="position-relative mb-3 mt-1 mt-md-0"
                  style={{
                    border: "1px dashed var(--vz-primary)",
                    borderRadius: "4px",
                    padding: "10px",
                  }}
                >
                  <span
                    className="text-primary position-absolute fs-13 px-1"
                    style={{
                      backgroundColor: "var(--vz-secondary-bg)",
                      top: "0px",
                      transform: "translateY(-50%)",
                    }}
                  >
                    {t("Business Info")}
                  </span>

                  <Row>
                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="companyName" className="form-label">
                          {t("Company Name")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="companyName"
                          type="text"
                          className="form-control"
                          id="companyName"
                          placeholder={t("Company Name")}
                          value={formik?.values?.companyName}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "companyName",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.companyName &&
                        formik?.errors?.companyName ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.companyName}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="ceoName" className="form-label">
                          {t("CEO Name")} <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="ceoName"
                          type="text"
                          className="form-control"
                          id="ceoName"
                          placeholder={t("CEO Name")}
                          value={formik?.values?.ceoName}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "ceoName",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.ceoName && formik?.errors?.ceoName ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.ceoName}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="businessRegistrationNumber"
                          className="form-label"
                        >
                          {t("Business Registration Number")}{" "}
                          <span className="text-danger">*</span>
                        </Label>

                        <PatternFormat
                          className={"form-control"}
                          placeholder={"Business Registration Number"}
                          value={formik?.values?.businessRegistrationNumber}
                          format="###-##-#####"
                          onValueChange={(values: any) => {
                            const { value } = values;

                            formik.setFieldValue(
                              "businessRegistrationNumber",
                              value
                            );
                          }}
                        />

                        {formik?.touched?.businessRegistrationNumber &&
                        formik?.errors?.businessRegistrationNumber ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.businessRegistrationNumber}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="contactEmail" className="form-label">
                          {t("Setting Contact Email")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="contactEmail"
                          type="text"
                          className="form-control"
                          id="contactEmail"
                          placeholder={t("Setting Contact Email")}
                          value={formik?.values?.contactEmail}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "contactEmail",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.contactEmail &&
                        formik?.errors?.contactEmail ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.contactEmail}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="contactPhone" className="form-label">
                          {t("Setting Contact Phone Number")}{" "}
                          <span className="text-danger">*</span>
                        </Label>

                        <PhoneInput
                          formikField={"contactPhone"}
                          formik={formik}
                          className=""
                          placeholder={t("Setting Contact Phone Number")}
                        />
                        {/* /070-8065-0184 */}
                        {/* <Input
                              name="contactPhone"
                              type="text"
                              className="form-control"
                              id="jobPostPurchaseWebURLInput"
                              placeholder={t("Setting Contact Phone Number")}
                              value={formik?.values?.contactPhone}
                              onChange={(event: any) => {
                                formik.setFieldValue(
                                  "contactPhone",
                                  event?.target?.value
                                );
                              }}
                            /> */}
                        {formik?.touched?.contactPhone &&
                        formik?.errors?.contactPhone ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.contactPhone}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="companyAddress" className="form-label">
                          {t("Setting Company Address")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="companyAddress"
                          type="text"
                          className="form-control"
                          id="jobPostPurchaseWebURLInput"
                          placeholder={t("Setting Company Address")}
                          value={formik?.values?.companyAddress}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "companyAddress",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.companyAddress &&
                        formik?.errors?.companyAddress ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.companyAddress}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="termsOfServiceUrl"
                          className="form-label"
                        >
                          {t("Setting Terms of Service")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="termsOfServiceUrl"
                          type="text"
                          className="form-control"
                          id="termsOfServiceUrl"
                          placeholder={t("Setting Terms of Service")}
                          value={formik?.values?.termsOfServiceUrl}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "termsOfServiceUrl",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.termsOfServiceUrl &&
                        formik?.errors?.termsOfServiceUrl ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.termsOfServiceUrl}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="privacyPolicyUrl"
                          className="form-label"
                        >
                          {t("Setting Privacy Policy")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="privacyPolicyUrl"
                          type="text"
                          className="form-control"
                          id="privacyPolicyUrl"
                          placeholder={t("Setting Privacy Policy")}
                          value={formik?.values?.privacyPolicyUrl}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "privacyPolicyUrl",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.privacyPolicyUrl &&
                        formik?.errors?.privacyPolicyUrl ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.privacyPolicyUrl}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="personalInfoConsentUrl"
                          className="form-label"
                        >
                          {t("Setting Consent to Collect Personal Info")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="personalInfoConsentUrl"
                          type="text"
                          className="form-control"
                          id="personalInfoConsentUrl"
                          placeholder={t(
                            "Setting Consent to Collect Personal Info"
                          )}
                          value={formik?.values?.personalInfoConsentUrl}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "personalInfoConsentUrl",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.personalInfoConsentUrl &&
                        formik?.errors?.personalInfoConsentUrl ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.personalInfoConsentUrl}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="eventPromotionConsentUrl"
                          className="form-label"
                        >
                          {t("Setting Consent to Receive Promotions")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="eventPromotionConsentUrl"
                          type="text"
                          className="form-control"
                          id="eventPromotionConsentUrl"
                          placeholder={t(
                            "Setting Consent to Receive Promotions"
                          )}
                          value={formik?.values?.eventPromotionConsentUrl}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "eventPromotionConsentUrl",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.eventPromotionConsentUrl &&
                        formik?.errors?.eventPromotionConsentUrl ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.eventPromotionConsentUrl}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="thirdPartyProvidingUrl"
                          className="form-label"
                        >
                          {t("Setting Third-Party Information Sharing")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="thirdPartyProvidingUrl"
                          type="text"
                          className="form-control"
                          id="thirdPartyProvidingUrl"
                          placeholder={t(
                            "Setting Third-Party Information Sharing"
                          )}
                          value={formik?.values?.thirdPartyProvidingUrl}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "thirdPartyProvidingUrl",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.thirdPartyProvidingUrl &&
                        formik?.errors?.thirdPartyProvidingUrl ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.thirdPartyProvidingUrl}
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col lg={6} xl={6} xxl={6}>
                <div
                  className="position-relative mb-3 mt-1 mt-md-0"
                  style={{
                    border: "1px dashed var(--vz-primary)",
                    borderRadius: "4px",
                    padding: "10px",
                  }}
                >
                  <span
                    className="text-primary position-absolute fs-13 px-1"
                    style={{
                      backgroundColor: "var(--vz-secondary-bg)",
                      top: "0px",
                      transform: "translateY(-50%)",
                    }}
                  >
                    {t("Order Info")}
                  </span>

                  <Row>
                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="titleKoreaInput" className="form-label">
                          {t("Job posting method")}{" "}
                          <span className="text-danger">*</span>
                        </Label>

                        <div className="d-flex justify-content-start align-items-center">
                          {LIST_SETTING_JOB_METHOD_OPTION?.map(
                            (item, index) => {
                              return (
                                <div
                                  className="d-flex justify-content-start align-items-center form-check me-3"
                                  key={index}
                                >
                                  <input
                                    className="form-check-input me-2"
                                    type="radio"
                                    name="jobPostFlow"
                                    id={`jobPostFlow-${String(item?.value)}`}
                                    value={item?.value}
                                    checked={
                                      item?.value ===
                                      formik?.values?.jobPostFlow
                                    }
                                    style={{ minWidth: "16px" }}
                                    onChange={(event) => {
                                      formik.setFieldValue(
                                        "jobPostFlow",
                                        item?.value
                                      );
                                    }}
                                  />
                                  <label
                                    className="form-check-label position-relative"
                                    htmlFor={`jobPostFlow-${String(
                                      item?.value
                                    )}`}
                                  >
                                    {t(item?.label)}
                                  </label>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="titleKoreaInput" className="form-label">
                          {t("Payment method")}{" "}
                          <span className="text-danger">*</span>
                        </Label>

                        <div className="d-flex justify-content-start align-items-center">
                          {LIST_SETTING_JOB_METHOD_OPTION?.map(
                            (item, index) => {
                              return (
                                <div
                                  className="d-flex justify-content-start align-items-center form-check me-3"
                                  key={index}
                                >
                                  <input
                                    className="form-check-input me-2"
                                    type="radio"
                                    name="paymentFlow"
                                    id={`paymentFlow-${String(item?.value)}`}
                                    value={item?.value}
                                    checked={
                                      item?.value ===
                                      formik?.values?.paymentFlow
                                    }
                                    style={{ minWidth: "16px" }}
                                    onChange={(event) => {
                                      formik.setFieldValue(
                                        "paymentFlow",
                                        item?.value
                                      );
                                    }}
                                  />
                                  <label
                                    className="form-check-label position-relative"
                                    htmlFor={`paymentFlow-${String(
                                      item?.value
                                    )}`}
                                  >
                                    {t(item?.label)}
                                  </label>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="jobPostPurchaseWebURL"
                          className="form-label"
                        >
                          {t("Web payment link")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="jobPostPurchaseWebURL"
                          type="text"
                          className="form-control"
                          id="jobPostPurchaseWebURLInput"
                          placeholder={t("Web payment link")}
                          value={formik?.values?.jobPostPurchaseWebURL}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "jobPostPurchaseWebURL",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.jobPostPurchaseWebURL &&
                        formik?.errors?.jobPostPurchaseWebURL ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.jobPostPurchaseWebURL}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="jobPostCreateWebNotice"
                          className="form-label"
                        >
                          {t("Redirect message from app to web job posting")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="jobPostCreateWebNotice"
                          type="text"
                          className="form-control"
                          id="jobPostCreateWebNoticeInput"
                          placeholder={t(
                            "Redirect message from app to web job posting"
                          )}
                          value={formik?.values?.jobPostCreateWebNotice}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "jobPostCreateWebNotice",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.jobPostCreateWebNotice &&
                        formik?.errors?.jobPostCreateWebNotice ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.jobPostCreateWebNotice}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="jobPostPurchaseWebNotice"
                          className="form-label"
                        >
                          {t("Redirect message from app to web payment")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="jobPostPurchaseWebNotice"
                          type="text"
                          className="form-control"
                          id="jobPostPurchaseWebNoticeInput"
                          placeholder={t(
                            "Redirect message from app to web payment"
                          )}
                          value={formik?.values?.jobPostPurchaseWebNotice}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "jobPostPurchaseWebNotice",
                              event?.target?.value
                            );
                          }}
                        />
                        {formik?.touched?.jobPostPurchaseWebNotice &&
                        formik?.errors?.jobPostPurchaseWebNotice ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.jobPostPurchaseWebNotice}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="importantNoteCreateJobPostiOS"
                          className="form-label"
                        >
                          {t("Important Note Create Job Post iOS")}{" "}
                          <span className="text-danger">*</span>
                        </Label>

                        <TextArea
                          rows={6}
                          value={formik?.values?.importantNoteCreateJobPostiOS}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "importantNoteCreateJobPostiOS",
                              event?.target?.value
                            );
                          }}
                          placeholder={t("Important Note Create Job Post iOS")}
                        />
                        {formik?.touched?.importantNoteCreateJobPostiOS &&
                        formik?.errors?.importantNoteCreateJobPostiOS ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.importantNoteCreateJobPostiOS}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="importantNoteCreateJobPostAndroid"
                          className="form-label"
                        >
                          {t("Important Note Create Job Post Android")}{" "}
                          <span className="text-danger">*</span>
                        </Label>

                        <TextArea
                          rows={6}
                          value={
                            formik?.values?.importantNoteCreateJobPostAndroid
                          }
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "importantNoteCreateJobPostAndroid",
                              event?.target?.value
                            );
                          }}
                          placeholder={t(
                            "Important Note Create Job Post Android"
                          )}
                        />
                        {formik?.touched?.importantNoteCreateJobPostAndroid &&
                        formik?.errors?.importantNoteCreateJobPostAndroid ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.importantNoteCreateJobPostAndroid}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="mb-3">
                        <Label
                          htmlFor="importantNoteCreateJobPostFold"
                          className="form-label"
                        >
                          {t("Important Note Create Job Post Fold")}{" "}
                          <span className="text-danger">*</span>
                        </Label>

                        <TextArea
                          rows={6}
                          value={formik?.values?.importantNoteCreateJobPostFold}
                          onChange={(event: any) => {
                            formik.setFieldValue(
                              "importantNoteCreateJobPostFold",
                              event?.target?.value
                            );
                          }}
                          placeholder={t("Important Note Create Job Post Fold")}
                        />
                        {formik?.touched?.importantNoteCreateJobPostFold &&
                        formik?.errors?.importantNoteCreateJobPostFold ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.importantNoteCreateJobPostFold}
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </div>

                <div
                  className="position-relative mb-3 mt-1 mt-md-0"
                  style={{
                    border: "1px dashed var(--vz-primary)",
                    borderRadius: "4px",
                    padding: "10px",
                  }}
                >
                  <span
                    className="text-primary position-absolute fs-13 px-1"
                    style={{
                      backgroundColor: "var(--vz-secondary-bg)",
                      top: "0px",
                      transform: "translateY(-50%)",
                    }}
                  >
                    {t("VOC")}
                  </span>

                  <Row>
                    <Col lg={12} className="mt-2">
                      <div className="d-flex gap-2">
                        <Label
                          htmlFor="newpasswordInput"
                          className="form-label"
                          style={{ minWidth: "114px" }}
                        >
                          {t("Enable VOC")}{" "}
                        </Label>
                        <div className="form-check form-switch mb-0">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="vocEnable"
                            name="vocEnable"
                            checked={!!formik?.values?.vocEnable}
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "vocEnable",
                                Number(event?.target.checked)
                              )
                            }
                          />
                        </div>
                      </div>
                    </Col>

                    {!!formik?.values?.vocEnable && (
                      <React.Fragment>
                        <Row>
                          <Col lg={4} className="mt-2">
                            <div className="d-flex gap-2 align-items-center h-100">
                              <Label
                                htmlFor="appEntry"
                                className="form-label"
                                style={{ minWidth: "114px" }}
                              >
                                {t("App Entry")}{" "}
                              </Label>
                              <div className="form-check form-switch mb-0">
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="appEntry"
                                  name="appEntry"
                                  checked={!!formik?.values?.appEntry}
                                  onChange={(event: any) =>
                                    formik.setFieldValue(
                                      "appEntry",
                                      Number(event?.target.checked)
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </Col>

                          <Col lg={8} className="mt-2">
                            <div
                              className="d-flex gap-2 align-items-center"
                              style={{ maxWidth: "460px" }}
                            >
                              <Label
                                htmlFor="entryThreshold"
                                className="form-label text-nowrap mb-0"
                              >
                                {t("Minimum Entry Criteria")}{" "}
                              </Label>
                              <Input
                                name="entryThreshold"
                                type="number"
                                className="form-control"
                                id="titleInput"
                                placeholder={t("Enter Minimum Entry Criteria")}
                                value={formik?.values?.entryThreshold}
                                onChange={(event: any) => {
                                  formik.setFieldValue(
                                    "entryThreshold",
                                    event?.target?.value
                                  );
                                }}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Col lg={12}>
                          <div className="d-flex gap-2 mt-2">
                            <Label
                              htmlFor="accountDeletion"
                              className="form-label text-nowrap"
                              style={{ minWidth: "114px" }}
                            >
                              {t("Account Deletion")}{" "}
                            </Label>
                            <div className="form-check form-switch mb-0">
                              <Input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="accountDeletion"
                                name="accountDeletion"
                                checked={!!formik?.values?.accountDeletion}
                                onChange={(event: any) =>
                                  formik.setFieldValue(
                                    "accountDeletion",
                                    Number(event?.target.checked)
                                  )
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </React.Fragment>
                    )}
                  </Row>
                </div>

                <div
                  className="position-relative mb-3 mt-1 mt-md-0"
                  style={{
                    border: "1px dashed var(--vz-primary)",
                    borderRadius: "4px",
                    padding: "10px",
                  }}
                >
                  <span
                    className="text-primary position-absolute fs-13 px-1"
                    style={{
                      backgroundColor: "var(--vz-secondary-bg)",
                      top: "0px",
                      transform: "translateY(-50%)",
                    }}
                  >
                    {t("Default Area Of Interest")}
                  </span>

                  <Row>
                    <Col md={6} lg={6}>
                      <div className="mb-3">
                        <Label htmlFor="contact_name" className="form-label">
                          {t("Province/Metropolitan City")}
                        </Label>
                        <DropdownOptionNew
                          name="region1"
                          dataList={regions || []}
                          placeholder={`${t("Province/Metropolitan City")}...`}
                          className="dropdown-status-rounded"
                          classNamePrefix="name-prefix"
                          initialValue={formik?.values?.defaultRegion?.id || null}
                          onChangeSelect={(e: any) =>{
                            if(formik?.values?.defaultRegion?.id !==  e?.value) {
                              formik?.setFieldValue("defaultRegion.id", e?.value)
                              formik?.setFieldValue("defaultRegion.name", e?.label)
                              formik?.setFieldValue("defaultSubRegion", {})
                            }
                          }}
                          isHasOptionAll={true}
                          optionAll={{ label: t("All Region"), value: -1 }}
                          isClearable={true}
                        />
                      </div>
                    </Col>

                    <Col md={6} lg={6}>
                      <div className="mb-3">
                        <Label htmlFor="contact_name" className="form-label">
                          {t("City/District")}
                        </Label>
                        <DropdownOptionNew
                          name="region2"
                          dataList={regions?.find((i: any) => i?.value === formik?.values?.defaultRegion?.id)?.subOptions || []}
                          placeholder={`${t("City/District")}...`}
                          className="dropdown-status-rounded"
                          classNamePrefix="name-prefix"
                          initialValue={formik?.values?.defaultSubRegion?.id || null}
                          onChangeSelect={(e: any) => {
                            formik?.setFieldValue("defaultSubRegion.id", e?.value)
                            formik?.setFieldValue("defaultSubRegion.name", e?.label)
                          }}
                          isHasOptionAll={false}
                          disabled={(!formik?.values?.defaultRegion?.id || formik?.values?.defaultRegion?.id === -1) ? true : false}
                          key={`region-${formik?.values?.defaultSubRegion?.id}`}
                          isClearable={true}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col lg={12}>
                <div className="hstack gap-2 justify-content-end my-4">
                  <button
                    className="btn btn-primary fs-14"
                    color="success"
                    type="submit"
                    disabled={isLoading}
                    style={{ width: "140px" }}
                  >
                    {isLoading ? (
                      <Spinner size="sm" className="me-2"></Spinner>
                    ) : (
                      <>{t("Update")}</>
                    )}
                  </button>
                </div>
              </Col>
            </Row>
          </form>
          <ToastContainer closeButton={false} limit={1} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AppSetting;
